module.exports = __webpack_public_path__ + "8442a84d.png";